import React, { Component, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get, post } from "util/requests";
import styles from "./visit_map.module.css";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Tooltip from "@mui/material/Tooltip";
import { OpenQueryIcon, ResolvedQueryIcon, RespondedQueryIcon, CheckIcon, DataIcon, DataIconBlue } from "ui/icons";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import strings from "strings";
import { arrayHaveCommonItems } from "util/helpers";
import router from "routes";

const renderIcon = (permissions, index, row_obj, return_boolean = false) => {
  let ret = [];
  let status = (row_obj && row_obj.status) || null;
  let query_status = (row_obj && row_obj.query_status) || null;
  let flags = (row_obj && row_obj.flags) || [];
  let count = row_obj?.count || null;

  if (permissions.includes("set_pi_signed_flag") || permissions.includes("view_pi_signed_flag")) {
    if (flags.includes("resite_signoff")) {
      ret.push(
        <div className={styles.re_icon}>
          <Tooltip title={strings.re_site_signoff} key={1}>
            S
          </Tooltip>
        </div>
      );
    } else if (flags.includes("all_site_signoff")) {
      ret.push(
        <div className={styles.all_icon}>
          <Tooltip title={strings.crf_site_signoff} key={1}>
            S
          </Tooltip>
        </div>
      );
    }
  }

  if (permissions.includes("set_monitored_flag") || permissions.includes("view_monitored_flag")) {
    if (flags.includes("remonitored")) {
      ret.push(
        <div className={styles.re_icon}>
          <Tooltip title={strings.re_monitor} key={1}>
            M
          </Tooltip>
        </div>
      );
    } else if (flags.includes("monitored") && !flags.includes("all_monitored")) {
      ret.push(
        <div className={styles.partial_icon}>
          <Tooltip title={strings.partial_monitored_flag} key={1}>
            M
          </Tooltip>
        </div>
      );
    } else if (flags.includes("all_monitored")) {
      ret.push(
        <div className={styles.all_icon}>
          <Tooltip title={strings.all_fields_monitored} key={1}>
            M
          </Tooltip>
        </div>
      );
    }
  }

  if (permissions.includes("set_qc_flag") || permissions.includes("view_qc_flag")) {
    if (flags.includes("reqa")) {
      ret.push(
        <div className={styles.re_icon}>
          <Tooltip title={strings.re_qa} key={1}>
            Q
          </Tooltip>
        </div>
      );
    } else if (flags.includes("qa") && !flags.includes("all_qa")) {
      ret.push(
        <div className={styles.partial_icon}>
          <Tooltip title={strings.partial_qa_flag} key={1}>
            Q
          </Tooltip>
        </div>
      );
    } else if (flags.includes("all_qa")) {
      ret.push(
        <div className={styles.all_icon}>
          <Tooltip title={strings.all_qa_flag} key={1}>
            Q
          </Tooltip>
        </div>
      );
    }
  }

  if (arrayHaveCommonItems(permissions, ["view_query_status", "start_query", "respond_query", "resolve_query"])) {
    if (query_status === "resolved") {
      ret.push(
        <Tooltip title={strings.page_query_closed} key={0}>
          <div className={styles.query_icon_wrapper}>
            <ResolvedQueryIcon fontSize="16px" />
          </div>
        </Tooltip>
      );
    } else if (query_status === "responded") {
      ret.push(
        <Tooltip title={strings.page_query_responded} key={1}>
          <div className={styles.query_icon_wrapper}>
            <RespondedQueryIcon fontSize="16px" />
          </div>
        </Tooltip>
      );
    } else if (query_status === "open") {
      ret.push(
        <Tooltip title={strings.page_query_open} key={6}>
          <div className={styles.query_icon_wrapper}>
            <OpenQueryIcon fontSize="16px" />
          </div>
        </Tooltip>
      );
    }
  }

  if (index === 0) return (row_obj && row_obj.name) || null;

  if (flags.includes("all_data")) {
    ret.push(
      <Tooltip title={strings.all_data_flag} key={5}>
        <DataIconBlue fontSize={"18px"} />
      </Tooltip>
    );
  } else if (flags.includes("data")) {
    ret.push(
      <Tooltip title={strings.partial_data_flag} key={4}>
        <DataIcon fontSize={"19px"} />
      </Tooltip>
    );
  }

  if (count) {
    ret.push(
      <div className={styles.count_icon}>
        <Tooltip title={strings.forms_on_visit}>{count}</Tooltip>
      </div>
    );
  }
  if (["available", "data"].includes(status) && !count && ret.length === 0) {
    ret.push(
      <Tooltip title={strings.crf_available_visit} key={4}>
        <CheckBoxOutlineBlankIcon key={3} sx={{ color: "#888", fontSize: "20px", lineHeight: "16px" }} />
      </Tooltip>
    );
  }

  if (!return_boolean) {
    return <div className={styles.icon_wrapper}>{ret}</div>;
  } else return ret.length > 0;
};

const rowIterater = (length = 6) => {
  return Array.from(Array(length).keys());
};

const get_row_item_crf = (row, current_column_index) => {
  if (current_column_index === 0) {
    return row;
  } else {
    return row.visits[current_column_index];
  }
};

const get_row_item_global_form = (row, current_column_index) => {
  if (current_column_index === 0) {
    return row;
  } else {
    return {
      status: (row.on_visits.find((v) => v.visit === current_column_index) && (row.status || "available")) || "no",
      count: row.on_visits.find((v) => v.visit === current_column_index)?.count || null,
      flags: row.on_visits.find((v) => v.visit === current_column_index)?.flags || null,
    };
  }
};

const get_leftmost_item_style = (index) => {
  let style = [];
  if (index === 0) {
    style = [styles.leftmost_item, styles.white_background];
  } else {
    style = [styles.item, styles.white_background];
  }
  return style.join(" ");
};

const get_header_item_style = (index) => {
  let style = [];
  if (index === 0) {
    style = [styles.leftmost_item, styles.white_background, styles.header_height];
  } else {
    style = [styles.header_item, styles.white_background, styles.grey_background, styles.header_height];
  }
  return style.join(" ");
};

const create_headings = (days_length, data) => {
  const headings1 = Array.from(Array(days_length).keys()).map((index) => {
    if (index === 0) {
      return "";
    } else {
      return (data[index] && data[index].name) || "";
    }
  });
  const headings2 = Array.from(Array(days_length).keys()).map((index) => {
    if (index === 0) {
      return "";
    } else {
      return (data[index] && data[index].milestone) || "";
    }
  });
  const headings3 = Array.from(Array(days_length).keys()).map((index) => {
    if (index === 0) {
      return "";
    } else {
      return (data[index] && data[index].description) || "";
    }
  });
  return { headings1, headings2, headings3 };
};

export default function VisitMap(props) {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.user.userData.permissions);

  const { subject_id } = props;
  const { study_id } = useParams();
  const [data, setData] = useState({ visits: {}, crfs: [], global_forms: [] });
  const [ready, setReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    get(`/patient_crf_status/${subject_id}`).then(({ data }) => {
      if (["no_domain_access", "no_site_access"].includes(data.status)) {
        setReady(data.status);
        router.navigate("/subjects");
      } else if (data) {
        setData(data);
        setReady(true);
      }
    });
  }, [subject_id]);

  useEffect(() => {
    post("/footprint", {
      path: location.pathname,
      action: "pageload",
      name: "visit_map",
      subject_id,
    });
  }, [location.pathname]);

  if (!ready) {
    return null;
  } else if (ready === "no_domain_access") {
    return (
      <div className={styles.wrapper}>
        <div>You do not have access to this subject.</div>
      </div>
    );
  }
  // const days_length = study_id === "1" ? 6 : 7;
  const days_length = Object.keys(data.visits).length + 1;
  // const days_length = 6;
  const { headings1, headings2, headings3 } = create_headings(days_length, data.visits);
  return (
    <div className={styles.wrapper}>
      <div className={styles.grid_row}>
        {headings1.map((heading, index) => (
          <div className={get_header_item_style(index)} key={(heading && heading + index) || Math.random()}>
            <strong>{heading}</strong>
          </div>
        ))}
      </div>
      <div className={styles.grid_row}>
        {headings2.map((heading, index) => (
          <div className={get_header_item_style(index)} key={(heading && heading + index) || Math.random()}>
            <strong>{heading}</strong>
          </div>
        ))}
      </div>
      <div className={styles.grid_row}>
        {headings3.map((heading, index) => (
          <div className={get_header_item_style(index)} key={(heading && heading + index) || Math.random()}>
            {heading}
          </div>
        ))}
      </div>
      <div>
        {data.crfs
          .filter(({ category }) => category === "main")
          .map((row) => (
            <div className={styles.grid_row} key={row.name || Math.random()}>
              {rowIterater(days_length).map((index) => (
                <div
                  key={`${row.name}-${index}`}
                  className={
                    index === 0 ? styles.leftmost_item : row.visits[index]?.id ? styles.item_clickable : styles.item
                  }
                  onClick={() => {
                    if (index !== 0 && row.visits[index]?.id) {
                      navigate(`/subjects/${subject_id}/edc/visit/${index}/crf/${row.visits[index].id}`);
                    }
                  }}
                >
                  {renderIcon(permissions, index, get_row_item_crf(row, index))}
                </div>
              ))}
            </div>
          ))}
      </div>
      {data.crfs.filter(({ category }) => category === "study_level_single_entry").length ? (
        <React.Fragment>
          <div className={styles.log_forms_title}>Study Level Single Entry Forms</div>
          <div>
            {data.crfs
              .filter(({ category }) => category === "study_level_single_entry")
              .map((row) => (
                <div className={styles.grid_row} key={row.name || Math.random()}>
                  {rowIterater(days_length).map((index) => (
                    <div
                      key={`${row.name}-${index}`}
                      className={
                        index === 0 ? styles.leftmost_item : row.visits[index]?.id ? styles.item_clickable : styles.item
                      }
                      onClick={() => {
                        if (index !== 0 && row.visits[index]?.id) {
                          navigate(`/subjects/${subject_id}/edc/visit/${index}/crf/${row.visits[index].id}`);
                        }
                      }}
                    >
                      {renderIcon(permissions, index, get_row_item_crf(row, index))}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </React.Fragment>
      ) : null}
      {data.global_forms.length ? (
        <React.Fragment>
          <div className={styles.log_forms_title}>Study Level Multiple Entry Forms</div>
          <div>
            {data.global_forms
              .filter((f) => !f.hidden)
              .map((row) => (
                <div className={styles.grid_row} key={row.name || Math.random()}>
                  {rowIterater(days_length).map((index) => (
                    <div
                      key={`${row.name}-${index}`}
                      className={
                        index === 0
                          ? styles.leftmost_item
                          : renderIcon(permissions, index, get_row_item_global_form(row, index), true)
                            ? styles.item_clickable
                            : styles.item
                      }
                      onClick={() => {
                        if (index !== 0 && renderIcon(permissions, index, get_row_item_global_form(row, index), true))
                          navigate(`/subjects/${subject_id}/edc/visit/${index}/multi_entry/${row.id}`);
                      }}
                    >
                      {renderIcon(permissions, index, get_row_item_global_form(row, index))}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </React.Fragment>
      ) : null}
      {data.corelab_crfs?.length ? (
        <React.Fragment>
          <div className={styles.log_forms_title}>Corelab Imaging Forms</div>
          <div>
            {data.corelab_crfs
              .filter(({ category }) => category === "main")
              .map((row) => (
                <div className={styles.grid_row} key={row.name || Math.random()}>
                  {rowIterater(days_length).map((index) => (
                    <div
                      key={`${row.name}-${index}`}
                      className={
                        index === 0 ? styles.leftmost_item : row.visits[index]?.id ? styles.item_clickable : styles.item
                      }
                      onClick={() => {
                        if (index !== 0 && row.visits[index]?.id) {
                          navigate(`/subjects/${subject_id}/edc/visit/${index}/corelab/${row.visits[index].id}`);
                        }
                      }}
                    >
                      {renderIcon(permissions, index, get_row_item_crf(row, index))}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </React.Fragment>
      ) : null}
      <div className={styles.visit_map_vesion}>
        CRF Version: {data.version}
        {data.corelab_crfs?.length ? ` | ${data.corelab_crf_version}` : ""}
      </div>
    </div>
  );
}
